"use client";

import { StoryblokComponent, useStoryblokState } from "@storyblok/react";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import { useUI } from "../context/UIContext";
import SignupModal from "@/components/SignupModal";
import JoinFlowInfoModal from "@/components/JoinFlowInfoModal";
import { useStartSignup } from "../hooks/useStartSignup";
import { useStartVerifyEmail } from "../hooks/useStartVerifyEmail";
import { Tournament } from "@/types/tournament";
import { sbBlok } from "@/types/sb-types";
import { isNowPlayingTournament } from "@/utils/dateUtils";

export default function HomeClient({
  story,
  newsStoriesData,
  proTournaments,
  teaserRowTournament,
}: {
  story: any;
  newsStoriesData: any;
  proTournaments: Tournament[];
  teaserRowTournament: Tournament | null;
}) {
  story = useStoryblokState(story);
  const { state: uiState } = useUI();
  const { data: session }: { data: any; status: string } = useSession();
  const [verifyEmailFlow, setVerifyEmailFlow] = useState<string | null>("");
  const [ygbActive, setYgbActive] = useState<string | null>("");

  useStartSignup();
  useStartVerifyEmail();

  useEffect(() => {
    if (verifyEmailFlow !== window.localStorage.getItem("verify_email_flow")) {
      setVerifyEmailFlow(window.localStorage.getItem("verify_email_flow"));
    }
    if (ygbActive !== window.localStorage.getItem("ygb_active")) {
      setYgbActive(window.localStorage.getItem("ygb_active"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uiState]);

  return (
    <>
      <SignupModal
        isOpen={
          uiState.isSignupModalOpen &&
          ygbActive === "true" &&
          session?.accessToken
        }
        tmToken={session?.accessToken}
        idTokenHint={session?.idToken}
      />
      <JoinFlowInfoModal />
      {story?.content?.body?.map((c: sbBlok) => {
        if (c.component === "header") {
          /* multiple running tournaments to show in header leaderboard */
          return (
            <StoryblokComponent
              key={c._uid}
              blok={c}
              tournaments={proTournaments?.filter((t) =>
                isNowPlayingTournament(t.startDate, t.endDate)
              )}
            />
          );
        }
        if (c.component === "teaser_row") {
          return (
            <StoryblokComponent
              key={c._uid}
              blok={c}
              tournament={teaserRowTournament}
            />
          );
        }
        if (c.component === "blog_posts_overview") {
          return (
            <StoryblokComponent
              key={c._uid}
              blok={c}
              stories={newsStoriesData.stories}
              isFirstPostLarge={false}
            />
          );
        }
        if (
          c.component === "tournament_card_overview" &&
          proTournaments?.length > 0
        ) {
          return (
            <StoryblokComponent
              key={c._uid}
              blok={c}
              story={story}
              tournaments={proTournaments}
            />
          );
        }
        return <StoryblokComponent key={c._uid} blok={c} />;
      })}
    </>
  );
}
